import { Endpoints } from "../../contants/endpoints";
import { api } from "../../lib/api";

export interface StoreDetail {
  id: string;
  name?: string | null;
  phoneNumber?: string | null;
  PhoneNumber?: string | null;
  hotline?: string | null;
  [key: string]: unknown;
}

export async function getStoreById(storeId: string): Promise<StoreDetail | null> {
  try {
    const res = await api.get(`${Endpoints.config.getStoreById}?storeId=${storeId}`);
    const body = res?.data;
    if (body?.success && body?.data) {
      return body.data as StoreDetail;
    }
    return null;
  } catch (error) {
    console.error("Fetch store by id failed:", error);
    return null;
  }
}
